// 水平折线图
export default {
  name: '水平折线图',
  type: 'hline',
  option: (data) => ({
    tooltip: {
      trigger: 'item',
      axisPointer: {
        type: 'shadow',
      },
      appendToBody: true,
      formatter(obj) {
        console.log(obj);
        return `${obj.marker}${obj.value[1]}<br/>${obj.name.replace(
          /(.{60})/g,
          '$1<br/>'
        )}`;
      },
    },
    legend: {
      show: false,
    },
    grid: {
      top: '2%',
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      show: true,
      data: data.x,
    },
    yAxis: {
      inverse: true,
      type: 'category',
      axisLabel: {
        show: false,
      },
    },
    series: data.y.map((item) => ({
      type: 'line',
      barWidth: 10,
      label: {
        show: true,
        distance: 1000,
        color: '#909399',
        position: [1, -16],
        formatter(obj) {
          return `{value|${obj.value[1]}}{title|${obj.value[0]}}`;
        },
        rich: {
          title: {
            padding: [0, 0, 0, 12],
          },
          value: {
            borderWidth: 1,
            borderColor: '#DCDFE6',
            borderRadius: 2,
            backgroundColor: 'rgb(244, 244, 245)',
            padding: [2, 4, 4, 4],
          },
        },
      },
      ...item,
    })),
  }),
};
